import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, ElementRef, Injector, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { PipeColumn } from '../models/pipe.model';
import { qDragAndDropCallback } from '../../services';
import { PipeBaseComponent } from '../pipe-base/pipe-base.component';
import { BaseQueovalItem, ParamApplication, QResult } from '../../models';

@Component({
  selector: 'q-comp-pipe-obligation',
  templateUrl: './pipe-obligation.component.html',
  styleUrls: ['./pipe-obligation.component.css', '../pipe-base/pipe-base.component.css']
})
export class PipeObligationComponent extends PipeBaseComponent implements OnInit {
  //Pour l'instant ça marche avec la version 14 d'angular mais seul Dieu sait si cela sera le cas dans le futur
  //Si ça ne marche plus avec les nouvelles versions ..... bon chance
  constructor(injector: Injector) {
    super(injector);

    //Prefix de la route du controlleur
    this.configParam.routePrefix = 'api/Pipe/Obligation/'

    //Table dans la quelle la propriété qui definit les colonnes se trouve
    this.configParam.columnDefinition.tablePrefix = 'Obl';
    //Alias de la table dans la quelle la propriété qui definit les colonnes se trouve (propablement optimisable pour marcher sans)
    this.configParam.columnDefinition.tableName = 'tDoObligation';

    //Nom de la grid qui va servir de modele
    this.configParam.gridModel = '';


    //GroupAPL pour enregistrer ou recuperer les configurations des colonnes  (tPAApplication)
    this.configParam.columnDefinition.columnFilterGroupe = 'OBLIGATION';

    this.configParam.columnDefinition.customColumnCode = "collaborateur";
    //Affiche ou non la barre de recherche
    this.configParam.quickSearch.show = false;

    //Definition de la liste des options de recherche pour la quickSearch
    //this.configParam.quickSearch.data = [];
    //Exemple:
    /* [
       //Chaque variable est expliquée dans la class Quick Search
       { titre: 'Apprenant', mode: 'CNT', tableName: 'TDOPersonne', propSearchName: 'NomfaPER', propDisplayName: 'NomfaPER,Pre01PER', relationName: 'REL_BO_CSOC_BO_CONTACT', isBoPere: false, key: 'cntcli.Ident' },
       //configuration pour avoir les tag, il ne peux apres avoir plusieurs ligne de tag 
       { titre: 'Tag', mode: 'TAG', relationName: 'REL_BO_STAGE_BO_TAG', key: 'stg.ident' },
     ]*/




    //Active ou non les filtres 
    this.configParam.filter.show = true;
    //GroupMOD pour enregistrer ou recuperer les modeles des filtres (tPAModele)
    this.configParam.filter.modelGroup = 'OBLIGATION';

  }


  //Zone des templates
  //Permet de maper les differents templates avec le composant (les html sont definis dans le html de la base)
  //Supprimer la ligne s'il n'est pas utilisé
  @ViewChild('cardObligation') cardTemplate: TemplateRef<any>;


  //Obligatoire ne marche pas s'ils ne sont pas définis ici (merci angular de ne pas comprendre l'intérêt de l'héritage =3)
  //@ViewChildren('ScrollViewport') viewPorts: QueryList<CdkVirtualScrollViewport>;
  @ViewChild('modalSettingColumn') modalSettingColumn: ElementRef;

  //Zone des templates
  //Permet de maper les differents templates avec le composant (les html sont definis dans le html de la base)
  //Supprimer la ligne s'il n'est pas utilisé
  @ViewChild('btnTemplate') btnTemplate: TemplateRef<any>;
  @ViewChild('columnHeaderTemplate') columnHeaderTemplate: TemplateRef<any>;
  @ViewChild('footerTemplate') footerTemplate: TemplateRef<any>;

  //Obligatoire ne marche pas s'ils ne sont pas définis ici (merci angular de ne pas comprendre intérêt de l'héritage =3)
  modalTemplate: TemplateRef<any>;


  //S'execute apres que le ngAfterViewInit de la base
  protected afterBaseInit() {

  }

  public openSettingCol() {

    this.currentColumnModel = new ParamApplication();
    this.selectedColumn = new Array<string>();

    this.http.postHttp<QResult<Array<BaseQueovalItem>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_ALL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<BaseQueovalItem>>) => {
        this.columnList = data.Value;
      });

    this.http.postHttp<QResult<Array<ParamApplication>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_MODEL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<ParamApplication>>) => {
        this.columnModelList = data.Value;
      });
    this.modalService.open(this.modalSettingColumn, { centered: true, size: 'lg', windowClass: 'qmodalover' });
  }

  //Recupere l'evenement du click sur les cartes du pipe 
  protected cardClickCallBack(data: qDragAndDropCallback) {
  }
  //Recupere l'evenement du drop des cartes du pipe 
  protected afterDropCallBack(data: qDragAndDropCallback) {
  }

  //Recupere les evenements de la grid
  protected gridClickCallBack(res: any) {
  }


  //S'execute juste avant la recuperation des cartes du pipe/grid
  //permet de faire du pretraitement de données avant la requete
  protected beforeGetCards() {
  }

  //S'execute juste apres la recuperation des cartes du pipe
  //permet de faire du posttraitement de données apres la requete
  protected afterGetCardsPipe(columns: Array<PipeColumn> | undefined = undefined) {
  }

  //S'execute juste apres la recuperation des cartes de la grid
  //permet de faire du posttraitement de données apres la requete
  //la liste des idents filtrées est passé en paramètre pour filtrer les requête en posttraitement
  protected afterGetCardsGrid(filtredIdent: String[] | undefined = undefined) {
    //Pour update les valeurs de la gird il faut affecter une datatable a la variable 'this.gridUpdateValue'
    //cette datatable doit obligatoirement contenir une propriété ident afin de faire le pivot avec les données de la grid    
  }
}

